import React, { useContext, useEffect } from 'react';

import { useNavigate } from 'react-router';
import { AccountContext } from '../context/account';
import useLoggedIn from '../hooks/useLoggedIn';
import DashboardPage from './dashboard';


const LoginPage: React.FC<any> = ({...res}) => {
  
  const isLoggedIn = useLoggedIn();
  const navigate = useNavigate()
  const {
    setShowLoginModal
  } = useContext(AccountContext);

  useEffect(() => {
    if (isLoggedIn === false) {
      setShowLoginModal(true);
    } else {
      navigate("/dashboard");
    }
  }, [isLoggedIn])

  return (
    <DashboardPage {...res} />
  )
}
export default LoginPage

export const Head: any = () => <title>Login page</title>